import React, { useEffect, useContext, useRef, useState } from "react";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import ReplayIcon from "@mui/icons-material/Replay";
import RefreshIcon from "@mui/icons-material/Refresh";
import { appLogger, Http } from "../../utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { useLocation, useNavigate } from "react-router-dom";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import NoProductMessage from "../../utils/common/NoProductMessage";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_SUPERADMIN,
  ROLE_USER_MANAGER,
} from "../../model";

import ChatMetricIssuesTable from "./ChatMetricIssuesTable";

import ChatDevices from "./ChatDevices";

import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import { CSVLink } from "react-csv";

import images from "../../global-styles/images";
import { ec2HostURL } from "../../utils/config";
import TicketMetricsTileCount from "./TicketMetricsTileCount";
import TicketMetricsissuesStatusChart from "./TicketMetricsissuesStatusChart";
import TicketMetricTeamMembers from "./TicketMetricTeamMembers";
import TickMetricFirstResponse from "./TickMetricFirstResponse";
import TickMetricMeanTimeResolution from "./TickMetricMeanTimeResolution";
import TickMetricAIAssist from "./TickMetricAIAssist";
import TicketMetricCSMActivity from "./TicketMetricCSMActivity";
import AddIcon from "@mui/icons-material/Add";
import {
  dateFilterList,
  getSelectedDateInUtc,
} from "../../utils/common/common";
import DownloadTicketsButton from "./DownloadTicketsButton";

const feedbacks = [
  {
    id: 1,
    ticketNumber: 26398,
    userFeedback: "The picture is not displaying properly",
    status: "pending",
    userCount: "+36k",
  },
  {
    id: 2,
    ticketNumber: 26398,
    userFeedback: "Disturbing grainy images ",
    status: "open",
    userCount: "+67",
  },
  {
    id: 3,
    ticketNumber: 342765,
    userFeedback: "Unable to see images properly",
    status: "replied",
    userCount: "+12",
  },
  {
    id: 4,
    ticketNumber: 143212,
    userFeedback: "Image quality is too poor",
    status: "closed",
    userCount: "+83",
  },
];

function TicketsMetricsDashboardContent(props: any) {
  const {
    userInfo,
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    setContextMetricPageStartDate,
    setContextMetricPageEndDate,
    ContextMetricPageStartDate,
    ContextMetricPageEndDate,
  } = useContext(UserContext) as UserLoginInfo;
  const location = useLocation();
  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });
  const currDate = new Date();
  const stDate = new Date(currDate);
  stDate.setHours(0, 0, 0, 0);
  currDate.setHours(23, 59, 59, 999);
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";

  stDate.setMonth(currDate.getMonth() - 1);
  stDate.setDate(stDate.getDate() + 1);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }

  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [productResponse, setProductResponse] = React.useState([] as any);
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);
  const [startDateValue, setStartDateValue] = React.useState(
    ContextMetricPageStartDate ? ContextMetricPageStartDate : stDateTimestamp
  );
  const [endDateValue, setEndDateValue] = React.useState(
    ContextMetricPageEndDate ? ContextMetricPageEndDate : currDateTimestamp
  );
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isChatbotMetricsLoading, setIsChatbotMetricsLoading] =
    React.useState(false);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [reportsTicketsData, setReportsTicketsData] = React.useState("");
  const [AIAssistUsage, setAIAssistUsage] = React.useState("");
  const [ticketChannels, setTicketChannels] = React.useState([]);

  const [reportsReviewTicketsData, setreportsReviewTicketsData] =
    React.useState("");

  const [ReportsTicketsTotalCountsData, setReportsTicketsTotalCountsData] =
    React.useState<any>("");
  const [ReportsTicketsRaisedData, setReportsTicketsRaisedData] =
    React.useState<any>([]);
  const [csmloading, setCSMLoading] = useState(false);
  const [csmpage, setcsmPage] = useState(1);
  const [hascsmMore, setHascsmMore] = useState(true);
  const [totalCSMCounts, setTotalCSMCounts] = useState(0);

  const [DevicesData, setDevicesData] = React.useState("");
  const [MostReferedArticlesData, setMostReferedArticlesData] =
    React.useState("");

  const [ReportsTicketsTopfiveCount, setReportsTicketsTopfiveCount] =
    React.useState(0);

  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");
  const [csvData, setCsvData] = React.useState<any>([]);
  const csvLinkRef = useRef<any>(null);
  const defaultDateFilter = dateFilterList.find(
    (option: any) => option.value === "last1Month"
  );
  const [selectedDateFilter, setSelectedDateFilter] =
    useState(defaultDateFilter);
  const [selectedDateInUTC, setSelectedDateInUTC] = useState(() => {
    return getSelectedDateInUtc(defaultDateFilter);
  });
  const [detectRefresh, setDetectRefresh] = React.useState(0);

  // setContextMetricPageEndDate,
  const getUTCDate = (dateValue: any) => {
    const utcDate = new Date(parseInt(dateValue, 10));
    return utcDate;
  };
  useEffect(() => {
    setContextMetricPageStartDate(startDateValue);
    setContextMetricPageEndDate(endDateValue);
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      resetCsmPaginationData();
      fetchLoctionsData();
      fetchAIAssistUsage();
      fetchticketChannels();
      fetchReportsTicketsTotalCountsData();
      fetchReportsTicketsRaisedData();
      fetchTicketsStatuses();
      fetchMostReferedArticlesData();
      // fetchReportReviewCategories();
      setIsLoading(true);
    }
  }, [product, version, selectedProVerDataType]);

  useEffect(() => {
    if (product && version && proVerUrl) {
      if (
        (startDateValue && endDateValue) ||
        (startDateValue === null && endDateValue === null)
      ) {
        resetCsmPaginationData();
        fetchLoctionsData();
        fetchAIAssistUsage();
        // fetchticketChannels();
        fetchReportsTicketsTotalCountsData();
        // fetchReportsTicketsRaisedData();
        fetchTicketsStatuses();
        fetchMostReferedArticlesData();
        // fetchReportReviewCategories();
        setIsLoading(true);
      }
    }
  }, [startDateValue, endDateValue, selectedDateFilter, detectRefresh]);

  useEffect(() => {
    fetchReportsTicketsRaisedData();
  }, [selectedDateFilter, detectRefresh]);

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  const changeStartDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(0, 0, 0, 0);
    const timestamp = dt.getTime();
    setStartDateValue(timestamp);
    setContextMetricPageStartDate(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
      setContextMetricPageEndDate(null);
    }
  };

  const changeEndDateValue = (e: any) => {
    const selectedDateString = e.target.value;
    const dt = new Date(selectedDateString);
    dt.setHours(23, 59, 59, 999);
    const timestamp = dt.getTime();
    setEndDateValue(timestamp);
    setContextMetricPageEndDate(timestamp);

    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            setProduct(ProVersion.product || response.productNameList[0].id);
            setVersion(
              ProVersion.version || response.productNameList[0].version
            );
            setSelectedProduct(response.productNameList[0]);

            setProVersion({
              product: ProVersion.product || response.productNameList[0].id,
              version:
                ProVersion.version || response.productNameList[0].version,
            });
            let tempurl = "";
            if (
              Array.isArray(contextProVersion) &&
              contextProVersion.length > 0
            ) {
              setcontextProVersion(contextProVersion);
              setselectedProVerData(contextProVersion);
              contextProVersion &&
                contextProVersion.length > 0 &&
                contextProVersion.map((data: any) => {
                  tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
                });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsLoading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsLoading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              // navigate("/products");
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsLoading(false);
        });
    }
  }, [userInfo]);

  const fetchLoctionsData = () => {
    if (proVerUrl) {
      setIsLoading(true);
      const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
      Http.get({
        url: `/api/v2/ticketMetrics/resolution?feedbackType=BUG_REPORT&${proVerUrl}${dateFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (response && response.ticketResponseMetrics) {
            setReportsTicketsData(response.ticketResponseMetrics);
          } else {
            setReportsTicketsData("");
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchAIAssistUsage = () => {
    if (proVerUrl) {
      setIsLoading(true);
      const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
      Http.get({
        url: `/api/v2/ticketMetrics/AiAssitedReply?feedbackType=BUG_REPORT&${proVerUrl}${dateFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (response && response.aiAssistedResponseMetrics) {
            setAIAssistUsage(response.aiAssistedResponseMetrics);
          } else {
            setAIAssistUsage("");
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };

  const fetchReportReviewCategories = () => {
    if (proVerUrl) {
      const dateFilter = `&from=${startDateValue ? startDateValue : ""}&to=${
        endDateValue ? endDateValue : ""
      }`;
      Http.get({
        url: `/api/v2/correlation/playstoreChart?${proVerUrl}&items=5`,
        state: userInfo,
      })
        .then((response: any) => {
          setreportsReviewTicketsData(response.topics);
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const resetCsmPaginationData = () => {
    setcsmPage(1);
    setHascsmMore(true);
    setReportsTicketsRaisedData([]);
  };

  const fetchReportsTicketsRaisedData = () => {
    if (proVerUrl) {
      setIsLoading(true);
      try {
        const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
        Http.get({
          url: `/api/v2/ticketMetrics/CSMActivity?feedbackType=BUG_REPORT&${proVerUrl}${dateFilter}&page=${csmpage}&limit=5`,
          state: userInfo,
        })
          .then((response: any) => {
            setIsLoading(false);
            if (
              response &&
              response.csmMetrics &&
              response.csmMetrics.length > 0
            ) {
              setTotalCSMCounts(response.total);
              setReportsTicketsRaisedData((prevItems: any) => [
                ...prevItems,
                ...response.csmMetrics,
              ]);
              setHascsmMore(true); // Update this based on your API response
              setcsmPage((prevPage) => prevPage + 1);
              setHascsmMore(response.csmMetrics.length > 0);
              // setReportsTicketsRaisedData(response.csmMetrics);
            }
          })
          .catch(() => {
            setIsLoading(false);
          });
      } catch (error) {
        // console.error("Error fetching data:", error);
      }
    }
  };
  const fetchReportsTicketsTotalCountsData = () => {
    if (proVerUrl) {
      setIsChatbotMetricsLoading(true);
      const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
      Http.get({
        url: `/api/v2/ticketMetrics/TicketDailyGraph?feedbackType=BUG_REPORT&${proVerUrl}${dateFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsTotalCountsData(response);
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          setIsChatbotMetricsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchTicketsStatuses = () => {
    if (proVerUrl) {
      const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
      setIsLoading(true);
      Http.get({
        url: `/api/v2/ticketMetrics/TicketCount?feedbackType=BUG_REPORT&${proVerUrl}${dateFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.ticketCounts &&
            response.ticketCounts.length > 0
          ) {
            setDevicesData(response.ticketCounts);
            setReportsTicketsTopfiveCount(response.Items.Count);
          } else {
            setDevicesData(response.ticketCounts);
            setReportsTicketsTopfiveCount(response.Items.Count);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchticketChannels = () => {
    if (proVerUrl) {
      const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
      setIsLoading(true);
      Http.get({
        url: `/api/v2/ticketMetrics/Channels?feedbackType=BUG_REPORT&${proVerUrl}${dateFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.ticketChannelMetrics &&
            response.ticketChannelMetrics.length > 0
          ) {
            setTicketChannels(response.ticketChannelMetrics);
          } else {
            setTicketChannels([]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };
  const fetchMostReferedArticlesData = () => {
    if (proVerUrl) {
      const dateFilter = `&startDate=${selectedDateInUTC.startDate}&endDate=${selectedDateInUTC.endDate}`;
      setIsLoading(true);

      Http.get({
        url: `/api/v2/ticketMetrics/KBArticle?feedbackType=BUG_REPORT&?${proVerUrl}${dateFilter}`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.kbArticles &&
            response.kbArticles.length > 0
          ) {
            setMostReferedArticlesData(response.kbArticles);
          } else {
            setMostReferedArticlesData(response.kbArticles);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsLoading(false);
    }
  };

  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);

    HandleContextSelectedProVer(getData);
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const clearDate = () => {
    setStartDateValue(stDateTimestamp);
    setEndDateValue(currDateTimestamp);
    setFilterDate({
      startDate: currDateTimestamp,
      endDate: currDateTimestamp,
    });
  };

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };

  const renderColor = (val: number) => {
    let colour = "";
    if (val >= 0 && val < 1) {
      colour = "#e51919";
    } else if (val >= 1 && val < 2) {
      colour = "#f97b28";
    } else if (val >= 2 && val < 3) {
      colour = "#f4c51a";
    } else if (val >= 3 && val < 4) {
      colour = "#76d43b";
    } else if (val >= 4 && val <= 5) {
      colour = "#028128";
    }
    return colour;
  };

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const [downloadReady, setDownloadReady] = React.useState(false);

  const dataFromListOfUsersState = () => {
    return csvData;
  };

  useEffect(() => {
    //    //define the heading for each row of the data
    // var csv = 'Name,Profession\n';

    // //merge the data with CSV
    // csvFileData.forEach(function(row) {
    //         csv += row.join(',');
    //         csv += "\n";
    // });

    // //display the created CSV data on the web browser
    // document.write(csv);

    // var hiddenElement = document.createElement('a');
    // hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    // hiddenElement.target = '_blank';

    // //provide the name for the CSV file to be downloaded
    // hiddenElement.download = 'Famous Personalities.csv';
    // hiddenElement.click();
    // var csvFile;
    // var downloadLink;

    // //define the file type to text/csv
    // csvFile = new Blob([csv], {type: 'text/csv'});
    // downloadLink = document.createElement("a");
    // downloadLink.download = filename;
    // downloadLink.href = window.URL.createObjectURL(csvFile);
    // downloadLink.style.display = "none";

    // document.body.appendChild(downloadLink);
    // downloadLink.click();
    if (csvLinkRef && csvLinkRef.current && downloadReady) {
      csvLinkRef.current.link.click();
      setDownloadReady(false);
    }
  }, [downloadReady]);

  const handleDateFilterChange = (_event: any, newValue: any) => {
    resetCsmPaginationData();
    setSelectedDateFilter(newValue);
    const dateInUtc = getSelectedDateInUtc(newValue);
    setSelectedDateInUTC(dateInUtc);
  };

  const handleResetFilter = () => {
    const dateInUtc = getSelectedDateInUtc(selectedDateFilter);
    setSelectedDateInUTC(dateInUtc);
    setTimeout(() => {
      setDetectRefresh((prev) => prev + 1);
    }, 1);
  };

  return (
    <Grid
      className={
        isLoading || isChatbotMetricsLoading
          ? " chart-item loader"
          : "chart-item"
      }
    >
      {renderNoProductMessage()}
      <Grid
        className="feedback-bug-filter"
        container
        sx={{ mb: 2 }}
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
      >
        <Grid container xs={12} sm={12} md={12} lg={12} xl={12}>
          {/* First 6-column section */}
          <Grid
            item
            xs={6}
            sm={12}
            md={12}
            lg={4}
            xl={4}
            className="pro-ver-dropdown-grid"
          >
            <ProductVersionDropdown
              productResponse={productResponse}
              selectedProVerData={selectedProVerData}
              selectedProVerDataFn={selectedProVerDataFn}
              contextProVersion={contextProVersion}
              type="cuvo-metrics"
            />
          </Grid>

          {/* Second 6-column section */}
          <Grid
            sx={{ display: "flex", justifyContent: "flex-end" }}
            item
            xs={6}
            sm={12}
            md={12}
            lg={8}
            xl={8}
          >
            <Box>
              <FormControl
                className="custom-select createdbyfilter multiple"
                fullWidth
              >
                <Autocomplete
                  value={selectedDateFilter}
                  disableClearable
                  options={dateFilterList}
                  sx={{ minWidth: 150, padding: "0px !important" }}
                  onChange={handleDateFilterChange}
                  renderInput={(params) => (
                    <TextField
                      sx={{ padding: "0px !important" }}
                      {...params}
                      label="Created At"
                    />
                  )}
                />
              </FormControl>
            </Box>{" "}
            &nbsp;
            <Box className="clear-option" title="Refresh">
              <RefreshIcon onClick={handleResetFilter} />
            </Box>
            <DownloadTicketsButton
              userInfo={userInfo}
              setIsLoading={setIsLoading}
              proVerUrl={proVerUrl}
              ticketData={DevicesData}
              startDate={selectedDateInUTC.startDate}
              endDate={selectedDateInUTC.endDate}
            />
          </Grid>
        </Grid>

        {/* <Grid className="article-startdate" item xs={5} sm={4} md={4} lg={1.5}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="date"
              value={startDateValue ? getDateString(startDateValue) : ""}
              onChange={changeStartDateValue}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>
        &nbsp;
        <Grid item xs={5} sm={4} md={4} lg={1.5}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              type="date"
              value={endDateValue ? getDateString(endDateValue) : ""}
              onChange={changeEndDateValue}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateString(startDateValue),
                max: currDate.toISOString().slice(0, 10),
              }}
            />
          </Box>
        </Grid>{" "} */}
        {/* <Grid item className="export-chat-select-btn" spacing={1}>
          <CSVLink
            data={csvData}
            headers={csvcolumns}
            asyncOnClick={true}
            // onClick={(e: any) => saveCsv()}
            // filename={`${"Chat_Export_"}${new Date().toISOString()}.csv`}
            filename={getExportFileName()}
            ref={csvLinkRef}
          ></CSVLink>

          {/* <FormControl
            className="custom-select"
            fullWidth
            sx={{ minWidth: 130 }}
          >
            <InputLabel>Filter</InputLabel>
            <Select
              labelId="filter-select"
              id="filter-select"
              // value={
              //   appliedFilter && Object.keys(appliedFilter).length > 0
              //     ? appliedFilter.id
              //     : ""
              // }
              label="Filter"
              // onChange={selectFilter}
            >
              <MenuItem
                sx={{
                  background: "none !important",
                  color: "#0157FF",
                  textTransform: "uppercase",
                  display: "flex",
                  fontSize: "12px !important",
                  fontWeight: "500",
                }}
                value={0}
                // onClick={() => {
                //   handleDrawerOpen();
                //   handleTabChange("", 0);
                //   handleSelectFilter({
                //     name: "",
                //     filters: [],
                //     advanceFilters: [],
                //   });
                // }}
              >
                <>
                  {" "}
                  <AddIcon />
                  Create / Manage
                </>
              </MenuItem>

              <Divider />
              <Typography className="dropmenu-label">Saved Filters</Typography>
              {/* {filterResponse.length > 0 &&
                  filterResponse.map((filter: any) => {
                    return (
                      <MenuItem
                        onClick={(event: any) => {
                          applyFilter(event, filter, "saved"),
                            handleSelectFilter(filter);
                          // searchClear();
                          setUserData([]);
                        }}
                        key={filter.id}
                        value={filter.id}
                      >
                        {filter.name}
                      </MenuItem>
                    );
                  })} 
            </Select>
          </FormControl> 
        </Grid> */}
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <TicketMetricsTileCount
              TicketMetricsTileCount={DevicesData}
              ReportsTicketsRaisedData={ReportsTicketsRaisedData}
              ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
              isChatbotMetricsLoading={isChatbotMetricsLoading}
            />
          </Grid>
        </Grid>
        {/* <Grid item xs={4}>
          <ReportNewArrivalTickets
            Topfivetickets={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={9}
          xl={9}
          sx={{ height: "380px !important" }}
        >
          <TicketMetricsissuesStatusChart
            startDateValue={startDateValue}
            endDateValue={endDateValue}
            Topfivetickets={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
            ReportsTicketsRaisedData={ReportsTicketsRaisedData}
          />
        </Grid>
        {/*   <Grid item xs={3}>
         <ChatTopTopics
            Topfivetickets={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          /> 
          <ChatLocation
            DevicesData={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid> */}
        <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
          <ChatDevices
            ticketChannels={ticketChannels}
            TicketsStatusesData={DevicesData}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Box className="chart-item ratings-chart">
            <TickMetricAIAssist
              AIAssistUsage={AIAssistUsage}
              ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Box className="chart-item ratings-chart" sx={{ height: "100%" }}>
            <TickMetricFirstResponse
              reportsTicketsData={reportsTicketsData}
              ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Box className="chart-item ratings-chart">
            <TickMetricMeanTimeResolution
              reportsTicketsData={reportsTicketsData}
              ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Box className="chart-item ratings-chart">
            {/* <TicketMetricTeamMembers teamembersdata={tempteam} /> */}
            <TicketMetricCSMActivity
              csmActivityDatas={ReportsTicketsRaisedData}
              fetchReportsTicketsRaisedData={fetchReportsTicketsRaisedData}
              hascsmMore={hascsmMore}
              totalCSMCounts={totalCSMCounts}
              ReportsTicketsRaisedData={ReportsTicketsRaisedData}
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Box className="chart-item ratings-chart">
            <ChatMetricIssuesTable
              title="Most Referred Articles"
              time="3"
              feedbacks={feedbacks}
              MostReferedArticlesData={MostReferedArticlesData}
            />
          </Box>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Box className="chart-item ratings-chart">
            <TicketMetricTeamMembers teamembersdata={tempteam} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
          <Box className="chart-item ratings-chart">
            <TicketMetricTeamMembers teamembersdata={tempteam} />
          </Box>
        </Grid> */}
        {/* <Grid item xs={12}>
          <ChatKBPerformance
            Topfivetickets={ReportsTicketsTopfive}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
        </Grid>*/}
        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Box className="chart-item ratings-chart">
            <ChatMetricIssuesTable
              title="Most Referred Articles"
              time="3"
              feedbacks={feedbacks}
              MostReferedArticlesData={MostReferedArticlesData}
            />
          </Box>
        </Grid> */}
        {/* <Grid item xs={6}>
          <ChatMetricIssuesTable
            title="Improvement Opportunities"
            time="3"
            feedbacks={feedbacks}
            reportsTicketsData={reportsTicketsData}
          />
        </Grid> */}
      </Grid>
      {/* <Grid container item xs={12} spacing={3}>
        <Grid item xs={8} spacing={3}>
          <Grid container spacing={1}>
            <TicketMetricsTileCount
              ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
            />
          </Grid>
          <Grid container mt={2}>
            <Grid item xs={12}>
              <FeedbackMetric
                title="TICKET CATEGORIES"
                time="3"
                feedbacks={feedbacks}
                reportsTicketsData={reportsTicketsData}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <ReportNewArrivalTickets
            Topfivetickets={ReportsTicketsTopfive}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
          <br></br>
        </Grid>
        <Grid container item spacing={3}>
          <Grid item xs={12}>
            <ReviewCategoriesMetric
              title="REVIEW CATEGORIES"
              time="3"
              reportsReviewTicketsData={reportsReviewTicketsData}
              // reportsTicketsData={reportsTicketsData}
            />
          </Grid>
        </Grid>
      </Grid> */}
    </Grid>
  );
}

export default withSnackbar(TicketsMetricsDashboardContent);
